import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<nb-side-foot>` — the sidebar footer slot (Mockup `web.css .side-foot`).
 *
 * Pinned to the bottom of the column (`margin-top:auto`) with a top divider.
 * Project arbitrary content (an avatar + the signed-in user, a sign-out
 * control, etc.). Inside a `.sidebar.admin` column the divider and the first
 * text line flip to the dark-variant colours.
 *
 * @example
 * <nb-side-foot>
 *   <nb-avatar … />
 *   <div><div>Mari Holt</div><div>Styreleder</div></div>
 * </nb-side-foot>
 */
@Component({
  selector: 'nb-side-foot',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'side-foot' },
  template: `<ng-content />`,
  styleUrl: './side-foot.css',
})
export class NbSideFoot {}
